import { createContext } from "react";

export default createContext({
  isAuth: false,
  id: null,
  name: null,
});
